import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddAttendanceComponent } from './add-attendance/add-attendance.component';
import { AttendanceListComponent } from './attendance-list/attendance-list.component';
import { EditAttendanceComponent } from './edit-attendance/edit-attendance.component';
import { ViewAttendanceComponent } from './view-attendance/view-attendance.component';
import { PermissionGuard } from 'app/shared/auth/auth-guard.service';
const routes: Routes = [
  {
    path:'',
    children:[
      {path:'',redirectTo:'attendance-list',pathMatch:'full'},
      {
        path:'add-attendance',component:AddAttendanceComponent
      },
      {
        path:'attendance-list',component:AttendanceListComponent,
        canActivate: [PermissionGuard],
        data: { roles: ['admin','Management','Training Moderator','Teacher','Finance'] } 
      },
      {
        path:'edit-attendance/:id',component:EditAttendanceComponent
      },
      {
        path:'attendance-view/:id',component:ViewAttendanceComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AttendenceRoutingModule { }
